<template>
    <div class="modal-background" v-if="showModal"></div>
    <div class="modal-card" v-if="showModal">
        <v-btn @click="$emit('close-modal'); audio.pause(); felixBagAuxStore.unmuteVideo()" variant="text" class="close">
            <img src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/34acc885-1b03-4a5a-b827-489477f81a78.svg"
                alt="">
        </v-btn>

        <img :src="profile.img" alt="">

        <div class="modal-message">
            <p>{{ profile.text }}</p>
        </div>

        <v-btn style="width: 85%" color="#660099" @click="submitProfile">Confirmar</v-btn>
    </div>
</template>

<script setup>
import { useFelixBagAuxStore } from '../../../../store';
import { defineProps, defineEmits, onMounted, watchEffect } from 'vue';

const props = defineProps(["showModal", "profile"])
defineEmits(["close-modal"])

const felixBagAuxStore = useFelixBagAuxStore();

const audios = {
    gestante: "//overmediacast-videos-sp.s3.sa-east-1.amazonaws.com/videobot/vivo/audios_parametrizados/card01_cut.mp3",
    fui_gestante: "//overmediacast-videos-sp.s3.sa-east-1.amazonaws.com/videobot/vivo/audios_parametrizados/card02_cut.mp3",
    parceria: "//overmediacast-videos-sp.s3.sa-east-1.amazonaws.com/videobot/vivo/audios_parametrizados/card03_cut.mp3",
    parceira_e_bebe_nasceu: "//overmediacast-videos-sp.s3.sa-east-1.amazonaws.com/videobot/vivo/audios_parametrizados/card04_cut.mp3",
    processo_adotivo: "//overmediacast-videos-sp.s3.sa-east-1.amazonaws.com/videobot/vivo/audios_parametrizados/card05_cut.mp3"
}

function submitProfile() {
    audio.pause();
    felixBagAuxStore.unmuteVideo()
    felixBagAuxStore.seekTo(felixBagAuxStore.scenes.preenchimento_de_cadastro)
}

const audio = document.createElement("audio");
onMounted(() => {
    watchEffect(() => {
        if (props.profile && props.showModal) {
            felixBagAuxStore.muteVideo()
            audio.pause();
            audio.src = audios[props.profile.name];
            audio.play();
        }
    });
});


</script>

<style scoped>
.modal-background {
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0.4;
    position: absolute;
    top: 0;
}

.modal-card {
    width: 85%;
    height: 60%;
    top: 20%;
    left: 7.5%;
    position: absolute;
    background-color: #fff;
    display: flex;
    border-radius: 12px;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
}

.modal-card img {
    width: 70%;
    height: auto;

}

.modal-message {
    text-align: center;
    background: url("//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/dd4f68dc-4d6e-40f9-907c-172efa7f0407.png");
    width: 85%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
}

.modal-message p {
    color: white;
    font-size: 20px;
    text-align: center;
    width: 90%;
}

.close {
    position: absolute !important;
    left: 75%;
    top: 5%;
}

.close img {
    width: 20px;
}
</style>